import $ from 'jquery';

$(document).ready(() => {
	let getDismissedNotifications = () => {
		let dismissedNotifications = sessionStorage.getItem('dismissed_notifications');
		return (dismissedNotifications != null) ? JSON.parse(dismissedNotifications) : {};
	}

	$('.notice-message').each(function() {
		let dismissButton = $(this).find('.js-close-button');

		if (dismissButton.length) {
			let linkID = $(dismissButton).attr('data-contentref');
			let isNotificationDismissed = getDismissedNotifications()[linkID];

			if (isNotificationDismissed == undefined) {
				$(dismissButton).on('click', () => {
					let dismissedNotifications = getDismissedNotifications();
					dismissedNotifications[linkID] = true;
					sessionStorage.setItem('dismissed_notifications', JSON.stringify(dismissedNotifications));
					$(this).addClass('d-none');
				})
			}
			// move on to next iteration if notification has been dismissed
			else return;
		}

		$(this).removeClass('d-none');
	});
});